import { frontendURL } from '../../../helper/URLHelper';
import CrmKanban from './CrmKanban.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_kanban',
    component: CrmKanban,
    meta: { ...commonMeta, crmView: 'kanban' },
  },
  {
    path: frontendURL('accounts/:accountId/crm/atividades'),
    name: 'crm_activities',
    component: CrmKanban,
    meta: { ...commonMeta, crmView: 'tasks' },
  },
  {
    path: frontendURL('accounts/:accountId/crm/relatorios'),
    name: 'crm_reports',
    component: CrmKanban,
    meta: { ...commonMeta, crmView: 'reports' },
  },
];
